if (!customElements.get('md-primary-bar')) {
  customElements.define('md-primary-bar', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.md-primary-bar');
      this.header = this.closest('m-header');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const dropdowns = [...this.header.querySelectorAll('.md-primary-dropdown')];
      const closeOthers = current => dropdowns.forEach(menu => { if (menu !== current) menu.open = false; });
      dropdowns.forEach(menu => {
        menu.querySelector('summary').addEventListener('click', event => {
          if (event.detail > 0 && window.matchMedia('(min-width:1024px) and (hover:hover)').matches) {
            event.preventDefault();
            closeOthers(menu);
            menu.open = true;
          }
        }, options);
        menu.addEventListener('toggle', () => { if (menu.open) closeOthers(menu); }, options);
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
        }, options);
        menu.addEventListener('mouseenter', () => { if (window.matchMedia('(min-width:1024px) and (hover:hover)').matches) { closeOthers(menu); menu.open = true; } }, options);
        menu.addEventListener('mouseleave', () => { if (window.innerWidth >= 1024 && !menu.contains(document.activeElement)) menu.open = false; }, options);
        menu.addEventListener('focusout', event => { if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false; }, options);
      });
      document.addEventListener('pointerdown', event => { if (!event.target.closest('.md-primary-dropdown')) closeOthers(); }, options);
      this.update = () => {
        this.style.height = `${this.bar.offsetHeight}px`;
        this.classList.toggle('is-sticky', this.dataset.sticky === 'true' && this.getBoundingClientRect().top < 0);
        const bottom = Math.max(0, this.bar.getBoundingClientRect().bottom);
        this.header.style.setProperty('--md-menu-bottom', `${bottom}px`);
      };
      window.addEventListener('scroll', this.update, { ...options, passive: true });
      window.addEventListener('resize', () => {
        closeOthers();
        if (window.innerWidth >= 1024 && drawer.classList.contains('open')) {
          const restoreFocus = drawer.contains(document.activeElement) || document.activeElement === toggle;
          this.header.megamenu?.closeMenu();
          if (restoreFocus) this.querySelector('.md-primary-nav summary,a')?.focus({ preventScroll: true });
        }
        this.update();
      }, options);
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.bar);
      const toggle = this.querySelector('.md-primary-mobile-toggle');
      const drawer = this.header.querySelector('#m-menu-drawer');
      this.drawerObserver = new MutationObserver(() => {
        const open = drawer.classList.contains('open');
        toggle.setAttribute('aria-expanded', String(open));
        if (open) drawer.querySelector('summary,a,button')?.focus();
      });
      this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('keydown', event => {
        if (!drawer.classList.contains('open')) return;
        if (event.key === 'Escape' && !event.target.closest('details[open]')) {
          event.preventDefault();
          toggle.click();
          toggle.focus();
        }
        if (event.key === 'Tab') {
          const controls = [toggle, ...drawer.querySelectorAll('a[href],button,summary,input,select')].filter(control => control.getClientRects().length && !control.disabled);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (event.shiftKey && document.activeElement === controls[1]) { event.preventDefault(); first.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          else if (!event.shiftKey && document.activeElement === first) { event.preventDefault(); controls[1]?.focus(); }
        }
      }, options);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.drawerObserver?.disconnect();
    }
  });
}
